import * as React from 'react'
import { memo } from 'react'

import { IIconsProps } from './icons.types'

const IconImageDefaultFill = ({ width, height, ...props }: IIconsProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 40 40'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.58333 5C7.05203 5 5 7.05203 5 9.58333V30.4167C5 31.2166 5.20495 31.9688 5.56521 32.6234L24.1613 15.7397C24.6383 15.3082 25.3649 15.3091 25.8408 15.7417L35 24.1132V9.58333C35 7.05203 32.948 5 30.4167 5H9.58333ZM11.25 14.1667C11.25 12.5558 12.5558 11.25 14.1667 11.25C15.7775 11.25 17.0833 12.5558 17.0833 14.1667C17.0833 15.7775 15.7775 17.0833 14.1667 17.0833C12.5558 17.0833 11.25 15.7775 11.25 14.1667Z'
        fill='#CFD5D9'
      />
      <path
        d='M9.58333 35C8.76119 35 7.98961 34.7835 7.32247 34.4045L24.9979 18.3542L34.9999 27.5L35 30.4167C35 32.948 32.948 35 30.4167 35H9.58333Z'
        fill='#CFD5D9'
      />
    </svg>
  )
}

export default memo(IconImageDefaultFill)
